import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import DIWPersonaliseContainer from '@/components/diw.personalise.container';

export default class DIWPersonalise extends TKCustomElementFactory {
    textarea?: HTMLTextAreaElement | HTMLInputElement;
    resetBtn?: HTMLButtonElement;
    salDocAttr?: string;
    isRequired: boolean;
    container?: DIWPersonaliseContainer;

    constructor() {
        super();

        this.textarea = this.querySelector('[data-tk-textarea]') || undefined;
        this.resetBtn = this.querySelector('[data-tk-reset]') || undefined;
        this.salDocAttr = this.getAttribute('data-tk-saldoc-attr') || undefined;
        this.isRequired = this.hasAttribute('data-tk-required');
        this.container = this.closest('[data-tk-personalise-container]') || undefined;
    }

    connectedCallback(): void {
        if (!this.container) throw new Error('DIWPersonalisationElement: Missing Container');
        if (!this.textarea) return;
        this.registerListener();
    }

    registerListener() {
        const updateBasketButton = this.updateBasketButton.bind(this);
        const resetInput = this.resetInput.bind(this);

        this.pushListener({ event: 'input', element: this.textarea!, action: updateBasketButton });
        this.resetBtn && this.pushListener({ event: 'click', element: this.resetBtn, action: resetInput });
    }

    resetInput() {
        this.textarea!.value = '';
        this.updateBasketButton();
    }

    updateBasketButton() {
        this.container!.updateBasketButton(this, this.textarea!.value);
    }
}
